import L from "leaflet";
import React, { useContext, useState, useRef } from "react";
import { renderToString } from "react-dom/server";
import { Marker, useMap, useMapEvents } from "react-leaflet";
import detectIt from "detect-it";
import { ToolContext } from "../context/ToolContext";
import { useSelector } from "react-redux";
import AssetIcon from "./assets/asset-icon/AssetIcon";

const MarkerTool = ({ create }) => {
  const markerRef = useRef(null);
  const { toolState } = useContext(ToolContext);
  const { mode, activeTool } = toolState;
  const iconSize = useSelector((state) => state.settings.iconSize);
  const [mousePosition, setMousePosition] = useState();

  const map = useMap();

  const styleIcon = () => {
    return iconMarker(activeTool, mode, iconSize);
  };

  const iconMarker = (activeTool, mode, iconSize) => {
    let classes = activeTool.class;

    if (activeTool.circleMarker) {
      classes += ` iconMarker badge-dark icon-${activeTool.borderColor} iconMarker-sz-${iconSize}`;
    } else {
      classes += " smallIconMarker";
    }
    if (activeTool.type === "cable") {
      classes += " connect";
    }
    classes += ` floating-mode-${mode}`;

    const icon = L.divIcon({
      name: activeTool.name,
      className: classes,
      html: renderToString(<AssetIcon assetStyle={activeTool} />),
      iconSize: activeTool.circleMarker ? [iconSize * 16, iconSize * 16] : [iconSize, iconSize],
    });
    return icon;
  };

  useMapEvents({
    mousemove(e) {
      setMousePosition(e.latlng);
    },
    click(e) {
      if (mode === "pipette") {
        return;
      }
      create(e.latlng);
    },
  });

  const getMarkerPosition = () => {
    if (mode === "pipette") {
      // Adjust the pipette position so that the tip is at the cursor position
      const iconSize = 11;
      const point = map.latLngToContainerPoint(mousePosition);
      point.x += iconSize;
      point.y -= iconSize;
      const markerPosition = map.containerPointToLatLng(point);
      return markerPosition;
    }
    return mousePosition;
  };

  return (
    <>
      {mousePosition && detectIt.hasMouse && (
        <Marker
          ref={markerRef}
          position={getMarkerPosition()}
          icon={styleIcon()}
          interactive={false}
        />
      )}
    </>
  );
};

export default MarkerTool;
